import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React from "react";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { AccountCreationHistoryModel } from "../../../../../../Wrap/Models/Domains/Account/AccountCreationHistoryModel";

interface INewAccountsChartProps {
    data: AccountCreationHistoryModel[];
}

const options = (data: AccountCreationHistoryModel[]): Highcharts.Options => {
    return {
        chart: {
            renderTo: "container",
            type: "column",
            backgroundColor: "transparent",
        },
        legend: {
            enabled: false,
        },

        title: {
            text: null,
        },

        credits: {
            enabled: false,
        },

        xAxis: {
            categories: data.map((ele) =>
                JsonDateParser.getFormatDateString(JsonDateParser.toDate(ele.DateCreated), "dd MM yy", true)
            ),
            crosshair: true,
        },
        yAxis: {
            min: 0,
            title: {
                text: null,
            },
        },

        plotOptions: {
            column: {
                pointPadding: 0,
                borderWidth: 0,
                pointWidth: 15,
            },
        },

        series: [
            {
                type: "column",
                name: "New accounts",
                color: "#3581D7",
                data: data.map((ele) => ele.CountOfAccountsCreated),
            },
        ],
    };
};

export const NewAccountsChart = (props: INewAccountsChartProps) => {
    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options(props.data)} />
        </>
    );
};
